// extracted by mini-css-extract-plugin
export var fadeIn = "_c5-1";
export var modalContent = "_c5-3";
export var overlay = "_c5-0";
export var popoverContent = "_c5-2";
export var results = "_c5-5";
export var searchInputWrapper = "_c5-4";